import { Button, Modal } from "antd";
import React, { useCallback } from "react";
import warningIcon from "../../assets/img/navy_warning.png";
import books from "../../store/ducks/books";

interface Props {
  visible: boolean;
  onOk: () => void;
}
const GeneralModal: React.FC<Props> = ({ visible, onOk }) => {
  const customFooter = [
    <Button
      style={{ display: "block", margin: "0 auto" }}
      key="ok"
      type="primary"
      onClick={onOk}
    >
      OK
    </Button>,
  ];

  return (
    <Modal
      closable={false}
      centered
      visible={visible}
      footer={customFooter}
      onOk={onOk}
    >
      <div style={{ textAlign: "center", marginBottom: 40 }}>
        <img
          src={warningIcon}
          alt="Warning"
          style={{ width: 80, height: 80 }}
        />
      </div>
      <div
        style={{
          fontWeight: "bold",
          textAlign: "center",
          fontSize: 20,
          marginBottom: 20,
        }}
      >
        Date Required
      </div>
      <p style={{ fontSize: 20, textAlign: "center" }}>
        Select the date of this event to ensure proper page sorting when
        creating books.
      </p>
    </Modal>
  );
};
export default GeneralModal;
